import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=195f5730&"
import script from "./voucher.vue?vue&type=script&lang=js&"
export * from "./voucher.vue?vue&type=script&lang=js&"
import style0 from "./voucher.vue?vue&type=style&index=0&id=195f5730&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports